import gql from 'graphql-tag';

export default gql`
    mutation UpdateLoadAccessorials($input: LoadAccessorialsEdit) {
        updateLoadAccessorials(input: $input) {
            errors
        }
    }
`;
